module.exports = __webpack_public_path__ + "static/app-steps-tarjeta-virtual-519b82e544825fdc09bb5ee610158ae6.gif";